<template>
  <div>
    <!-- Breadcrumb -->
    <HeaderBreadcrumbs :items="[
      { label: 'Banner', to: { name: 'banner' } },
      { label: this.bannerName }
    ]" :title="this.bannerName" />

    <!-- General Information -->
    <div class="bg-white p-4 my-3 rounded-lg shadow-sm">
      <div class="flex justify-between items-center">
        <h2 class="font-bold text-lg mb-3">General Information</h2>
        <router-link class="bg-blue-700 flex justify-start items-center rounded-lg py-2 px-2.5 text-white"
          :to="{ path: '/banner-edit/' + item_id }">
          <svg class="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
              clip-rule="evenodd" />
            <path fill-rule="evenodd"
              d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
              clip-rule="evenodd" />
          </svg>
          Edit Detail
        </router-link>


      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex-col">
          <div class="w-full">
            <span class="font-semibold">Banner Name</span>
            <p class="text-gray-500">{{ this.bannerName }}</p>
          </div>
          <div class="flex justify-start items-start ">
            <div class="w-full"><span class="font-semibold">Start Date</span>
              <p class="text-gray-500">{{ formatDateStartAndEnd(this.valid_from) }}</p>
            </div>
            <div class="w-full">
              <span class="font-semibold">End Date</span>
              <p class="text-gray-500">{{ formatDateStartAndEnd(this.valid_to) }}</p>
            </div>
          </div>
          <div class="w-full">
            <span class="font-semibold">Platform</span>
            <p class="text-gray-500 w-max mt-1.5" :class="platformClass(this.client)">
              {{ platform(this.client) }}
            </p>
          </div>
          <p><span class="font-semibold">Banner Image</span></p>
          <div class="mt-1.5">
            <img :src="this.imgItem" alt="Banner Image" class="max-w-xs object-cover rounded-lg" style="height: 144px;" />
          </div>
        </div>
        <div class="w-full">
          <span class="font-semibold">Created Date</span>
          <p class="text-gray-500">{{ formatDate(this.created) }}</p>
          <span class="font-semibold">Last Modified</span>
          <p class="text-gray-500">{{ formatDate(this.modified) }}</p>
        </div>

      </div>
    </div>

    <!-- Banner Detail -->
    <div class="bg-white p-4 my-3 rounded-lg shadow-sm">
      <h2 class="font-bold text-lg mb-3">Banner’s Detail</h2>
      <div class="grid grid-cols-2 gap-4 items-start">
        <div>
          <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-1">Banner Type</p>
            <span :class="BannerTypeColor(this.banner_type)">{{ this.banner_type }}</span>
          </div>
          <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Display Zone</p>
            <span class="text-gray-500"> Display on {{ this.displayZone }} Page</span>
          </div>
          <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Display Price</p>
            <span class="text-gray-500 capitalize"> Show {{ this.showPrice }} Price Only</span>
          </div>
          <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Sort Priority</p>
            <span class="text-gray-500 capitalize"> {{ this.sortPriority }}</span>
          </div>
          <div class="mt-0 mb-3">
            <p class="font-semibold mb-1">Banner Terms and Condition</p>

      <div>
    <p
      class="text-sm mb-0 text-gray-500 overflow-hidden transition-all duration-300"
      :class="showMore ? 'whitespace-normal' : 'truncate'"
      style="line-height: 1.5rem;"
    >
      {{ termAndCondition || '-' }}
    </p>

    <button
      v-if="termAndCondition.length > 100"
      class="text-gray-700 text-sm mt-1 float-right focus:outline-none"
      @click="toggleReadMore"
    >
      {{ showMore ? 'Read Less' : 'Read More' }}
      <i :class="showMore ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"></i>
    </button>
  </div>
          </div>
        </div>
        <div>
       <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Campaign</p>
            <span class="text-gray-500 capitalize">{{campaign.name ?? campaign}}</span>
          </div>
            <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Notification Title</p>
            <span class="text-gray-500 capitalize">
              {{ notificationTitle || '-' }}
            </span>
          </div>
             <div class="w-full flex-col mb-3">
            <p class="font-semibold mb-0">Notification Display Date</p>
            <span class="text-gray-500 capitalize">
              {{ formatDateStartAndEnd(notificationDisplayDate) }}
            </span>
          </div>
          <div class="mt-0 mb-3">
            <p class="font-semibold mb-0">Notification Content</p>
            <p class="text-sm mb-2 text-gray-500">{{ notificationContent || '-'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs.vue';
import moment from 'moment';
import constant from '../../store/constant';

export default {
  name: 'bannersDetail',
  components: {
    HeaderBreadcrumbs,
  },
  data() {
    return {
      bannerName: '',
      item_id: '',
      valid_from: '',
      valid_to: '',
      created: '',
      modified: '',
      client: null,
      banner_type: '',
      imgItem: '',
      showMore: false,
      displayZone: '',
      showPrice: '',
      sortPriority: '',
      termAndCondition: '',
      notificationTitle:'',
      campaign:'',
      notificationDisplayDate:'',
      notificationContent:''
    }
  },
  computed: {
    ...mapState({
      isError: (state) => state.banners.isError,
      isLoading: (state) => state.banners.isLoading,
      errorMessage: (state) => state.banners.errorMessage,
      successMessage: (state) => state.banners.successMessage,
      item: (state) => state.banners.item || {},
    }),
  },
  watch: {
    item: function () {
      if (!Object.keys(this.item).length) return;
      this.setDetailData();
    },
  },
  created: function () {
    let id = this.$route.params.id;
    this.item_id = id;
    this.fetchNotifBannersByid(id);
  },
  methods: {
    ...mapActions('campaign', ['searchCampaign']),
    ...mapActions('banners', [
      'fetchBannersByid',
      'fetchCampaignById',
      'fetchNotifBannersByid',
      'fetchCampaignId',
    ]),
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD hh:mm ");
    },
    formatDateStartAndEnd(date) {
      return moment(date).format("DD MMMM YYYY ");
    },
    platform(key) {
      if (key == 1) {
        return 'IOS'
      } else if (key == 2) {
        return 'Android'
      } else if (key == 7) {
        return 'Web Store'
      }
    },
    toggleReadMore() {
      this.showMore = !this.showMore
    },
    platformClass(key) {
      if (key === 1) {
        return 'bg-yellow-100 text-yellow-800 px-2.5 py-1 rounded-lg text-xs';
      } else if (key === 2) {
        return 'bg-green-100 text-green-800 px-2 py-1 rounded-lg text-xs';
      } else if (key === 7) {
        return 'bg-blue-100 text-blue-800 capitalize px-2 py-1 rounded-lg text-xs';
      }
    },
    BannerTypeColor(status) {
      switch (status) {
        case 'banner only':
          return 'bg-gray-100 text-gray-700 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'open url':
          return 'bg-yellow-100 text-yellow-700 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'landing page':
          return 'bg-green-200 text-green-800 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'static':
          return 'bg-purple-200 text-purple-800 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'promo':
          return 'bg-blue-200 text-blue-800 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'brand':
          return 'bg-black-200 text-black-800 capitalize text-xs px-2.5 py-1 rounded-lg';
        case 'buffet':
          return 'bg-red-200 text-red-800 capitalize text-xs px-2.5 py-1 rounded-lg';
      }
    },
      containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
    setDetailData() {
      const data = this.item
      this.bannerName = data.name
      this.valid_from = data.valid_from
      this.valid_to = data.valid_to
      this.created = data.created
      this.modified = data.modified
      this.client = data.client_id[0]
      this.banner_type = data.banner_type
      this.imgItem = constant.IMG_URL_STATIC_BANNER.URL + data.image_normal
      this.displayZone = data.zone
      this.showPrice = data.show_price
      this.sortPriority = data.sort_priority
      this.termAndCondition = data.term_and_condition
      this.notificationTitle = data.notifications_banner.title
      this.notificationDisplayDate = data.notifications_banner.notice_date
      this.notificationContent = data.notifications_banner.content
       if (this.containsOnlyNumbers(data.payload)) {
        this.fetchCampaignId(data.payload).then((response) => {
          this.campaign = response?.data?.data?.rows[0];
        });
      } else {
        this.campaign = data.payload === 'undefined' ? ' ' : data.payload ;
      }
    }
  }
}
</script>
